import {createSlice} from "@reduxjs/toolkit";
import {storage} from './Storage';
import {getMerchantInfo, MERCHANT_STATE} from './merchant'

const COMMUNE_STATE = 'commune';

const communeSlice = createSlice({
    name: COMMUNE_STATE,
    initialState: {
        communeId: 0,
        name: '',
        merchantId: 0,
        avatar: '',
        role: '',
        communes: [],
        communeNum: 0
    },
    reducer: {
        setCurrentCommune: (state, action) => {
            state.communeId = action.payload.communeId;
            state.name = action.payload.name;
            state.avatar = action.payload.avatar;
            state.role = action.payload.role;
            storage.set(COMMUNE_STATE, {
                communeId: action.payload.communeId,
                name: action.payload.name,
                avatar: action.payload.avatar,
                role: action.payload.role,
            });
        },
    }
});

const {setCurrentCommune} = communeSlice.actions;
const isCreateMerchant = (state) => {
    if (state(COMMUNE_STATE).merchantId === getMerchantInfo(state(MERCHANT_STATE)).merchantId) {
        return true;
    }
    return false;
}
export {
    COMMUNE_STATE,
    communeSlice,
    isCreateMerchant,
    setCurrentCommune,
};
export default communeSlice.reducer;